import React from "react";
import {
    MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCol, MDBSpinner
} from "mdb-react-ui-kit";

export const MDBCustomAlert = ({ color, show = true, children, setFeedback }) => {
    return <> {show &&
    <div className={`alert alert-${color} alert-dismissible show`}
        role="alert">
        {children}
        <MDBBtn type="button" className="btn-close" color="none"
                aria-label="Close" onClick={() => { setFeedback('') }} />
    </div>
    }</>
}

export const LoadingSpinner = ({color = 'korprimary', size='5rem'}) =>
    <div className='text-center mb-3'>
        <MDBSpinner color={color}
            style={{ borderWidth: '0.75rem', width: size, height: size }}>
        </MDBSpinner>
    </div>

export const LoadingDataWrapper = ({ waitingFor, children }) =>
    <>
        {Object.keys(waitingFor).length === 0 ? <LoadingSpinner /> : children}
    </>

export const CommonCard = ({ cardTitle, cardClass='', bg='korprimary', children }) =>
    <MDBCard className={cardClass}>
        <MDBCardHeader background={`${bg} bg-gradient`} tag='h5'
                       className='text-light text-center fw-bold'>
            {cardTitle}
        </MDBCardHeader>
        <MDBCardBody>
            {children}
        </MDBCardBody>
    </MDBCard>

export const CommonCol = ({ lgSize = '6', ...rest }) =>
        <MDBCol size='12' lg={lgSize} className='mb-5' {...rest} />

const CommonColCard = ({ cardTitle, colLgSize, children }) =>
    <CommonCol lgSize={colLgSize}>
        <CommonCard cardTitle={cardTitle} cardClass='h-100'>
            {children}
        </CommonCard>
    </CommonCol>

export const CommonColCard4 = (props) => <CommonColCard colLgSize="4" {...props} />

export const CommonColCard6 = (props) => <CommonColCard colLgSize="6" {...props} />

export const DivTextCenter = (props) => <div className="text-center" {...props} />
